const url = 'https://www.wrike.com/form/eyJhY2NvdW50SWQiOjI0Mjk1ODQsInRhc2tGb3JtSWQiOjU2NDQzM30JNDc4NzcxNjQ2NjMzMAkxZmExMjM0ZGIzY2IwYTQyYTBlOWYwYjgyZWY1MjdhNWQzZTU2NjA4YzhiZGZkYTIwMmJhM2U4ZjUwYmY3ZDkx';

export default url;
